import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AceTagsModule} from './tags/tags.module';
import {CapitalizeFirstPipe} from './pipes/capitalizefirst.pipe';

@NgModule({
  declarations: [
    // DropdownDirective
    CapitalizeFirstPipe
  ],
  imports: [
    AceTagsModule
  ],
  exports: [
    CommonModule,
    AceTagsModule,
    // DropdownDirective
    CapitalizeFirstPipe
  ],
  providers: [
  ]
})
export class SharedModule {}
